import { ChangeColor } from './ChangeColor';

export class ChangeTextColor extends ChangeColor {
  type: string = 'ChangeTextColor';
}
